import { makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import themes from 'styles/themes';
import './style.scss';
const useStyles = makeStyles(() => ({
    optionContainer: {
        padding: '0 10px',
        margin: '8px 0',
        '&:last-child img': {
            display: 'none',
        },
        '& p': {
            display: 'none',
        },
        '&:last-child p': {
            display: 'block',
        },
        '&:last-child h6': {
            backgroundColor: themes.palette.common.white,
            color: themes.palette.primary.main,
        },
    },
    optionName: {
        // backgroundColor: "#CCDADB",
        // padding: "4px 6px",
        // width: "auto",
        // marginBottom: "6px",
        // borderRadius: 4,
        display: 'flex',
        alignItems: 'center',
        fontWeight: 400,
    },
    optionImage: {
        height: 25,
        width: 'auto',
        maxWidth: 120,
        marginRight: 10,
    },
    optionItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    optionDes: {
        color: themes.palette.primary.main,
        fontSize: 14,
        fontWeight: 400,
        fontFamily: 'PoppinsRegular',
    },
}));
export const getStrongLabel = (item, input) => {
    if (item && typeof item === 'string') {
        const temp0 = item.replace('Create ', '');
        const temp = temp0.split('');
        const renderTitle = temp.map((item, index) => {
            const temp2 = input.split('').find((x) => x.toLowerCase().includes(item.toLowerCase()));
            if (temp2) {
                return (
                    <div style={{ whiteSpace: 'pre', color: themes.palette.primary.light }} key={index}>
                        <b style={{ color: themes.palette.primary.light }}>{item}</b>
                    </div>
                );
            } else {
                return (
                    <div style={{ whiteSpace: 'pre', color: themes.palette.primary.light }} key={index}>
                        {item}
                    </div>
                );
            }
        });
        return (
            <div
                style={{
                    backgroundColor: themes.palette.primary.main,
                    width: 'auto',
                    borderRadius: 4,
                    padding: '4px 6px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    maxWidth: '100vw',
                }}
            >
                {renderTitle}
            </div>
        );
    } else {
        return null;
    }
};
export const MyOption = (props) => {
    const { innerProps, innerRef } = props;
    const classes = useStyles();
    return (
        <article ref={innerRef} {...innerProps} className={classes.optionContainer}>
            <div className={classes.optionItem}>
                <h6 className={classes.optionName}>
                    {props.selectProps.inputValue !== '' &&
                        props.selectProps.inputValue?.toLowerCase() !== props.label?.toLowerCase() && (
                        <p style={{ marginRight: 4, marginBottom: 0 }}>Create</p>
                    )}
                    {getStrongLabel(props.data.label, props.selectProps.inputValue)}
                </h6>
                {Boolean(props?.data?.imageUrl?.length) && (
                    <img src={props.data.imageUrl} alt="" className={classes.optionImage} />
                )}
            </div>

            <div className={classes.optionDes}>{props.data.description}</div>
        </article>
    );
};
export const IndicatorsContainer = (props) => {
    return (
        <div style={{ display: 'none' }}>
            <components.IndicatorsContainer {...props} />
        </div>
    );
};
interface IProps {
    handleSelectItem?: any;
    data: any[];
    defaultValue: any;
    onChangeInput?: any;
    field?: any;
    placeholder?: any;
    error?: any;
    anchorId?: any;
    isHiddenLabel?: boolean;
    isDisabled?: boolean;
    isMulti?: boolean;
}
const useContainerStyle = makeStyles(() => ({
    container: {
        position: 'relative',
        marginTop: 10,
        '& .css-1hwfws3': {
            paddingLeft: 0,
        },
    },
    selectIcon: {
        position: 'absolute',
        right: '10px',
        top: '50%',
    },
    headerLabel: {
        fontSize: '14px',
        position: 'absolute',
        fontFamily: 'PoppinsRegular',
        marginBottom: 10,
        color: themes.palette.common.white,
        transform: 'scale(0.9) translateX(-2px)',
        fontWeight: 600,
        lineHeight: '24px',
    },
}));
function CustomizeSelect({
    handleSelectItem,
    data,
    defaultValue,
    onChangeInput,
    field,
    placeholder,
    error,
    anchorId,
    isHiddenLabel,
    isDisabled,
    isMulti = true,
}: IProps) {
    const classes = useContainerStyle();
    const [value, setValue] = useState('');
    const [dataOptions, setDataOptions] = useState(data);
    const [listDefault, setListDefault] = useState(defaultValue);
    const [showHeader, setShowHeader] = useState(false);
    useEffect(() => {
        if ((defaultValue?.value || defaultValue?.name) && !isMulti) {
            setListDefault([
                {
                    ...defaultValue,
                    label: defaultValue?.value || defaultValue?.name,
                },
            ]);
        } else if (defaultValue && defaultValue?.length > 0) {
            setListDefault(defaultValue);
        } else {
            setListDefault([]);
        }
    }, [defaultValue, isMulti]);
    useEffect(() => {
        if (data && data.length > 0) {
            setDataOptions(
                data.filter((x) => {
                    const checkValue = x.label || x.title || '';
                    return checkValue.toLowerCase().includes(value.toLowerCase());
                }),
            );
        }
    }, [data, value]);
    // const [menuIsOpen, setMenuIsOpen] = useState(false)
    const handleInputChange = (newValue) => {
        onChangeInput && newValue && onChangeInput(field, newValue);
        setValue(newValue);
        return newValue;
    };
    // useEffect(() => {
    //     if (value !== '') {
    //         setMenuIsOpen(true)
    //     } else {
    //         setMenuIsOpen(false)
    //     }
    // }, [value])
    useEffect(() => {
        if ((listDefault && listDefault.length > 0) || value) {
            setShowHeader(true);
        }
    }, [listDefault, value]);
    const handleSelect = (option) => {
        handleSelectItem(option);
        setListDefault(option);
    };
    const scrollToElement = () => {
        try {
            // if (anchorId)
            //     (document.getElementById(anchorId) as any).scrollIntoView(true);
        } catch (error) {}
    };

    return (
        <div className={`customize-select-wrap ${classes.container}`}>
            {placeholder &&
                (isHiddenLabel ? null : (
                    <p
                        className={classes.headerLabel}
                        style={{
                            color: error ? 'red' : themes.palette.primary.main,
                            display: showHeader ? '' : 'none',
                        }}
                    >
                        {placeholder}
                    </p>
                ))}
            <div className="customize-select">
                <CreatableSelect
                    inputValue={value}
                    value={listDefault}
                    isDisabled={isDisabled}
                    onInputChange={handleInputChange}
                    getValue={handleInputChange}
                    maxMenuHeight={250}
                    menuShouldScrollIntoView={true}
                    id={anchorId}
                    // menuIsOpen={menuIsOpen}
                    closeMenuOnSelect={true}
                    components={{ IndicatorsContainer, Option: MyOption }}
                    isMulti={isMulti}
                    options={dataOptions}
                    onChange={(e) => handleSelect(e)}
                    placeholder={!showHeader ? (placeholder ? placeholder : 'Select...') : null}
                    styles={{
                        placeholder: (base) => ({
                            color: error ? '#923636' : '#1a1a1a80',
                            fontFamily: 'PoppinsRegular',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '14px',
                        }),
                        control: (base) => ({
                            padding: '8px 0',
                            margin: '10px 0 0 0',
                            borderBottom: `1px solid ${themes.palette.grey['300']}`,
                        }),
                        multiValue: (styles, { data }) => {
                            return {
                                ...styles,
                                backgroundColor: themes.palette.primary.main,
                                fontFamily: 'PoppinsRegular',
                                fontSize: '14px',
                                color: 'green',
                            };
                        },
                        multiValueLabel: (styles, { data }) => ({
                            ...styles,
                            color: themes.palette.common.white,
                            fontFamily: 'PoppinsRegular',
                            fontSize: '14px',
                        }),
                        singleValue: (styles) => {
                            return {
                                ...styles,
                                fontFamily: 'PoppinsRegular',
                                fontSize: '14px',
                            };
                        },
                        singleValueLabel: (styles) => ({
                            ...styles,
                            fontFamily: 'PoppinsRegular',
                            fontSize: '14px',
                        }),
                    }}
                    onFocus={() => {
                        isHiddenLabel ? setShowHeader(false) : setShowHeader(true);
                        scrollToElement();
                    }}
                    onBlur={() => {
                        if (listDefault.length === 0) {
                            setShowHeader(false);
                        }
                    }}
                />
            </div>
        </div>
    );
}

export default CustomizeSelect;
